import { useCallback } from "react";
import { useTranslation } from "react-i18next";

import { showCustomToast } from "../components/CustomToast";
import { exportBillingLocationsThunk } from "../reducers/billingLocationsReducer";
import { useAppDispatch } from "../store";
import { BillingLocationsTableType } from "../types/billingLocations";

export const useBillingLocationsExport = () => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();

  const handleExport = useCallback(
    async (tableType: BillingLocationsTableType, billingId?: number) => {
      const result = await dispatch(exportBillingLocationsThunk({ tableType, billingId }));

      if (exportBillingLocationsThunk.fulfilled.match(result)) {
        showCustomToast(t("billingLocationsTableContainer.exportSuccess"), { type: "success" });
      } else if (exportBillingLocationsThunk.rejected.match(result)) {
        showCustomToast(t("billingLocationsTableContainer.exportError"), { type: "error" });
      }
    },
    [dispatch, t]
  );

  return { handleExport };
};
